import React from "react";
import { PageHero } from "../components";

const CheckoutPage = () => {
  return (
    <div>
      <PageHero />
      <div className='page'>
        <h1>Checkout</h1>
      </div>
    </div>
  );
};

export default CheckoutPage;
